import { render } from "./QuienesSomos.vue?vue&type=template&id=0aeecb29&ts=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=ts"
export * from "./QuienesSomos.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__